<template>
  <div class="h-full p-8 pt-0 w-full overflow-auto" ref="pageContainer">
    <DataGetter
      @dataAvailable="
        data => {
          products = data
          this.isLoading = false
        }
      "
      contentId="products"
    />

    <DataGetter
      @dataAvailable="
        data => {
          subscription = data?.metaData || {}
        }
      "
      contentId="subscription"
    />
    <DataGetter
      @dataAvailable="
        data => {
          platformAccessSubscription = data?.metaData || {}
        }
      "
      contentId="platformAccessSubscription"
    />
    <NewProductAdder
      class="pt-12"
      v-if="productAdding"
      @closeRequired="productAdding = false"
    />
    <ProductUpdater
      class="pt-12"
      v-else-if="productUpdating"
      :productData="productToUpdate"
      @closeRequired="productUpdating = false"
    />
    <div v-else>
      <div
        class="flex w-full justify-between items-center sticky top-0 pt-8 pb-4 z-[2] bg-[#f4f4f5]"
      >
        <div class="text-4xl title-color">Produits</div>
        <div>
          <button
            v-if="products.length > 0"
            @click="addNewProduct"
            class="buttonComponent"
          >
            Ajouter un produit
          </button>
        </div>
      </div>
      <div v-if="isLoading || products.length > 0">
        <div class="py-4"></div>
        <div class="relative">
          <div class="w-full overflow-auto">
            <div>
              <div
                class="flex items-center justify-between p-4 rounded-2xl text-sm uppercase gap-8"
              >
                <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
                  Détails Produit
                </div>

                <!-- Tags -->
                <div class="gap-2 w-[10rem] min-w-[10rem]">Catégories</div>

                <!-- Colors -->
                <!-- <div class="flex gap-1 w-[5rem] min-w-[5rem]">Couleurs</div> -->

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[5rem] min-w-[5rem]">Montant</div>

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[5rem] min-w-[5rem]">En Stock</div>

                <div class="flex gap-6 w-[5rem] min-w-[5rem]">Status</div>
                <!-- SKU -->
                <!-- <div class=" text-gray-700">{{ product.sku }}</div> -->

                <!-- Actions -->
                <div
                  class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
                >
                  Actions
                </div>
              </div>
            </div>
            <div class="flex flex-col gap-4">
              <div
                v-for="(product, index) in isLoading
                  ? shimmerProducts
                  : products"
                :key="index"
                class="flex items-center justify-between min-w-max p-4 rounded-2xl gap-8 [&>div]:relative"
                :class="{ shimmerElement: product.shimmer }"
              >
                <div
                  class="pointer-events-none !absolute min-w-8 left-0 w-full rounded-xl h-[4lh] bg-white p-"
                ></div>
                <!-- Product Info -->
                <div class="flex items-center gap-4 w-[20rem] min-w-[20rem]">
                  <img
                    v-if="product.image || product.images"
                    :src="product.image || product.images[0]"
                    class="min-w-[4rem] w-[4rem] h-[4rem] object-cover rounded-lg"
                  />
                  <div class="w-[16rem]">
                    <h3 class="font-semibold title-color truncate">
                      {{ product.name }}
                    </h3>
                    <p class="truncate">
                      {{ product.description }}
                    </p>
                  </div>
                </div>

                <!-- Tags -->
                <div class="gap-2 w-[10rem] min-w-[10rem]">
                  <div
                    class="inline-block m-1 px-3 py-1 text-xs font-medium text-gray-600 bg-gray-100 rounded-lg"
                  >
                    {{ product.category }}
                  </div>
                </div>

                <!-- Colors -->
                <!-- <div class="flex gap-1 w-[5rem] min-w-[5rem]">
                <span
                  v-for="(color, cIndex) in product.colors"
                  :key="cIndex"
                  :style="{ backgroundColor: color }"
                  class="w-5 h-5 rounded-full border"
                ></span>
              </div> -->

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[5rem] min-w-[5rem]">
                  <div>{{ product.price }} {{ product.currency }}</div>
                </div>

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[5rem] min-w-[5rem]">
                  <div v-if="!product.isDigitalProduct">
                    {{ product.quantity }}
                  </div>
                </div>

                <!-- Price and Quantity -->
                <div class="flex gap-6 w-[5rem] min-w-[5rem]">
                  <button
                    class="buttonComponent px-4 py-3"
                    :class="{
                      'bg-primary-50 border-2 border-primary-300 description-color whitespace-nowrap':
                        !product.isPublished,
                    }"
                  >
                    {{ product.isPublished ? 'Publié' : 'En attente' }}
                  </button>
                </div>

                <!-- SKU -->
                <!-- <div class=" text-gray-700">{{ product.sku }}</div> -->

                <!-- Actions -->
                <div
                  class="flex items-center gap-2 w-[8rem] min-w-[8rem] justify-end pr-4"
                >
                  <DropdownComponent
                    :selects="[
                      {
                        name: 'Editer',
                        onClick() {
                          updateProduct(product)
                        },
                      },
                      {
                        name: 'Supprimer',
                        onClick() {
                          deleteProduct(product)
                        },
                      },
                    ]"
                    hideArrow
                    maxHeight="270px"
                    displayKey="name"
                    toLeft
                    :onSelect="
                      selected => {
                        selected.onClick()
                      }
                    "
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="w-6 h-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                      />
                    </svg>
                  </DropdownComponent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="h-[60vh] w-full flex-col items-center justify-center flex"
        v-else
      >
        <div class="w-1/5">
          <img src="@/assets/images/empty/no-product.png" alt="" />
        </div>
        <div class="py-1"></div>
        <div class="text-center">
          <div class="py-1"></div>
          <div class="text-4xl title-color font-bold">Aucun produit trouvé</div>
          <div class="py-1"></div>
          <div class="text-lg">
            Votre boutique est vide. <br />
            Vous n'avez aucun produit
          </div>
          <div class="py-3"></div>
          <div class="flex justify-center gap-6">
            <button @click="addNewProduct" class="buttonComponent">
              Créer un produit
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- <NewProductAdderDialog /> -->
    <EventListener
      :events="[
        'failed_to_publish_product',
        'failed_to_unpublish_product',
        'product_published',
        'product_unpublished',
        'product_deleted',
        'failed_to_delete_product',
      ]"
      @failed_to_publish_product="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Echec de publication',
            body: 'La publication du produit a échoué. Veuillez réessayer',
          })
        }
      "
      @failed_to_unpublish_product="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Echec de dépublication',
            body: 'La dépublication du produit a échoué. Veuillez réessayer',
          })
        }
      "
      @product_published="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Produit publié',
            body: 'La publication du produit a réussi.',
          })
        }
      "
      @product_unpublished="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Produit dépublié',
            body: 'La dépublication du produit a réussi.',
          })
        }
      "
      @failed_to_delete_product="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Echec de suppression',
            body: 'La suppression du produit a échoué. Veuillez réessayer',
          })
        }
      "
      @product_deleted="
        () => {
          $Events.dispatchEvent('toast_notification', {
            title: 'Produit supprimé',
            body: 'La supression du produit a réussi.',
          })
        }
      "
    />
  </div>
</template>

<script>
import NewProductAdder from '@/components/product/NewProductAdder.vue'
import ProductUpdater from '@/components/product/ProductUpdater.vue'
import DataGetter from '@/components/utils/DataGetter.vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import EventListener from '@/components/utils/EventListener.vue'

export default {
  name: 'homeComponent',
  components: {
    ProductUpdater,
    DataGetter,
    DropdownComponent,
    EventListener,
    NewProductAdder,
  },
  data() {
    return {
      eventsIds: [],
      products: [],
      isLoading: true,
      productAdding: false,
      subscription: {},
      productUpdating: false,
      shimmerProducts: [
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
        { shimmer: true },
      ],
      productToUpdate: {},
    }
  },
  beforeUnmount() {},
  mounted() {},
  methods: {
    addNewProduct() {
      if (!this.platformAccessSubscription.isActive) {
        this.$Events.dispatchEvent('platform_access_required')
        return
      }
      // this.$Events.dispatchEvent('new_product_adding_required')
      this.productAdding = true
      this.$refs.pageContainer.scrollTo(0, 0)
    },
    updateProduct(product) {
      if (
        !this.subscription.isActive &&
        !this.platformAccessSubscription.isActive
      ) {
        this.$Events.dispatchEvent('platform_access_required')
        return
      }
      this.productToUpdate = product
      this.productUpdating = true
      this.$refs.pageContainer.scrollTo(0, 0)
    },
    toogleProductPublishing(product) {
      if (product.isPublished) this.unpublishProduct(product)
      else this.publishProduct(product)
    },
    publishProduct(product) {
      console.log('will publish')
      this.$Events.dispatchEvent('product_publish_requested', {
        id: product.id,
      })
    },
    unpublishProduct(product) {
      this.$Events.dispatchEvent('product_unpublish_requested', {
        id: product.id,
      })
    },
    async deleteProduct(product) {
      const prompt = await this.$Events.sendDataRequestResolve(
        'customPrompt',
        {
          title: `Voulez vous vraiment supprimer ${product.name} ?`,
          subTitle:
            'Si vous supprimez ce produit, vous ne pouvez plus le retrouvé',

          successText: 'Supprimer produit',
          cancelText: 'Conserver produit',
        },
        9999999999,
      )
      if (!prompt.accepted) return null
      this.$Events.dispatchEvent('product_deletion_requested', {
        id: product.id,
      })
    },
  },
}
</script>
